import "./styles.css";

import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import Popup from "reactjs-popup";

import closeIcon from "../../../../assets/icons/icons-close.svg";
import searchIcon from "../../../../assets/images/searchproicon.svg";
import { settlementStatusOptions } from "../../../../lib/constants";
import { convertToUnix } from "../../../../utils/utils";
import { DateInput } from "../../../ui";
import Button from "../../../ui/Button";
import CustomInput from "../../../ui/CustomInput";
import CustomNumberInput from "../../../ui/CustomNumberInput";
import CustomSelect from "../../../ui/CustomSelect";

const AdvanceSearchBtn = ({ setSearchTerm }) => {
  const {
    register,
    handleSubmit,
    control,
    formState: { formState, errors },
    reset,
  } = useForm();

  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);

  const processForm = (data, close) => {
    //console.log({data})
    if (convertToUnix(data.from_invoice_time) > convertToUnix(data.to_invoice_time)) {
      toast.error("تاریخ شروع باید قبل تر از تاریخ اتمام باشد ");
      return;
    }

    const processedData = {
      ...data,
      from_invoice_time: data.from_invoice_time ? convertToUnix(data.from_invoice_time) : "",
      to_invoice_time: data.to_invoice_time ? convertToUnix(data.to_invoice_time) : "",
    };
    setSearchTerm(processedData);
    close();
    reset();
  };

  return (
    <>
      <Popup
        trigger={
          <div className="cursor-pointer flex justify-center items-center px-2 py-2 rounded-v-lg bg-dark gap-2">
            <p className="text-neutral-20 text-title-sm-regular">جستجوی پیشرفته</p>
            <img className="w-5 h-5" src={searchIcon} alt="download" />
          </div>
        }
        modal
        nested
      >
        {(close) => (
          <div
            className="w-full bg-neutral-10 mb-5 rounded-v-lg p-2 md:p-8 mx-auto flex flex-col max-h-[70vh] max-w-[80%]  md:max-h-[650px] min-w-[80vw]  md:min-w-[500px] md:min-h-[500px] z-0 no-scrollbar "
            dir="rtl"
            style={{ overflowY: "auto", overflowX: "visible" }}
          >
            <div className="flex-between p-2 ">
              <p className="text-title-3xl-regular">فیلدهای جستجو</p>
              <button onClick={close}>
                <img className="cursor-pointer" src={closeIcon} alt="close-icon" width={24} height={24} />
              </button>
            </div>
            <hr />
            <form
              onSubmit={handleSubmit((data) => processForm(data, close))}
              className="flex flex-col  flex-1  "
            >
              <div className={`grid grid-cols-1 md:grid-cols-4 w-full gap-4 my-2   `}>
                <DateInput
                  dateType={"search"}
                  control={control}
                  name={"from_invoice_time"}
                  label={"تاریخ پرداخت از"}
                  placeholder={"روز/ماه/سال"}
                  type={"text"}
                  errors={errors.from_invoice_time}
                  classNainvoice
                  maxDate={tomorrow}
                  hour={0}
                  minute={0}
                  second={0}
                />
                <DateInput
                  dateType={"search"}
                  control={control}
                  register={register}
                  name={"to_invoice_time"}
                  label={"تا"}
                  placeholder={"روز/ماه/سال"}
                  type={"text"}
                  errors={errors.to_invoice_time}
                  className={""}
                  maxDate={tomorrow}
                  hour={23}
                  minute={59}
                  second={59}
                />
                <CustomNumberInput
                  control={control}
                  name={"from_amount"}
                  label={"از مبلغ (ریال)"}
                  placeholder={""}
                  type={"text"}
                  errors={errors.from_amount}
                  className={""}
                />
                <CustomNumberInput
                  control={control}
                  name={"to_amount"}
                  label={"تا مبلغ (ریال)"}
                  placeholder={""}
                  type={"text"}
                  errors={errors.to_amount}
                  className={""}
                />

                <CustomNumberInput
                  control={control}
                  name={"exact_amount"}
                  label={"مبلغ دقیق (ریال)"}
                  placeholder={""}
                  type={"text"}
                  errors={errors.exact_amount}
                  className={""}
                />

                <CustomInput
                  control={control}
                  register={register}
                  name={"vanda_tracking_code"}
                  label={"شناسه وندا"}
                  placeholder={""}
                  type={"text"}
                  errors={errors.vanda_tracking_code}
                  className={""}
                />

                <CustomSelect
                  control={control}
                  name={"settlement_status"}
                  label={"وضعیت تسویه"}
                  errors={errors.settlement_status}
                  options={settlementStatusOptions}
                />
              </div>

              <div className="flex gap-2  w-fit mr-auto  mt-auto ">
                <div
                  tab={"1"}
                  className="text-[14px] md:text-[16px] md:mr-auto px-2 py-1 md:px-6 md:py-2 border-2 border-dark hover:bg-slate-200 text-dark rounded-[12px] "
                  onClick={(e) => {
                    reset();
                  }}
                >
                  پاک کردن فیلترها
                </div>
                <Button
                  tab={"2"}
                  className="flex items-center gap-2 mr-auto px-2 py-1 md:px-6 md:py-2 bg-dark hover:bg-slate-600 text-white rounded-[12px] "
                  type="submit"
                >
                  <p> اعمال</p>
                  <img className="w-5 h-5" src={searchIcon} alt="download" />
                </Button>
              </div>
            </form>
          </div>
        )}
      </Popup>
    </>
  );
};

export default AdvanceSearchBtn;
